import sliceCreator from '../../index.js';
import {RAWMATERIAL_HISTORY} from '../../../constants/index.js';
const _getRawMaterialHistoryAction = sliceCreator('RAWMATERIAL_HISTORY', RAWMATERIAL_HISTORY, 'get');
 
const { asyncAction: getRawMaterialHistoryAction, reducer, clearData: clearGetRawMaterialHistoryAction } = _getRawMaterialHistoryAction;
 
export default reducer;
 
export {
    getRawMaterialHistoryAction,
    clearGetRawMaterialHistoryAction,
}
 